import {useCan} from '@/shared/hooks/use-permissions'
import {useConfirmDeleteSolution} from '@/modules/drug-catalog/solutions/api'
import {SolutionSummary} from '@/modules/drug-catalog/solutions/components/solution-drawer/solution-summary'
import {SolutionDrawerTabsList} from '@/modules/drug-catalog/solutions/components/solution-drawer/tabs-list'
import {AboutTab} from '@/modules/drug-catalog/solutions/components/solution-drawer/tabs/about'
import {HistoryTab} from '@/modules/drug-catalog/solutions/components/solution-drawer/tabs/activity'
import {MedicationProfilesTab} from '@/modules/drug-catalog/solutions/components/solution-drawer/tabs/medication-profiles'
import {getSolutionDrawerId} from '@/modules/drug-catalog/solutions/components/solution-drawer/util'
import {isSolutionDeletable} from '@/modules/drug-catalog/solutions/functions'
import {drawer} from '@cypro/ui/components'
import {DrawerBody, DrawerFooter, DrawerHeader} from '@cypro/ui/components'
import {DeleteResourceButton} from '@cypro/ui/components/ui/delete-resource-button'
import {LinkButton} from '@cypro/ui/components/ui/link-button'
import {Tooltip} from '@cypro/ui/components/ui/tooltip'
import {useSolutionDrugContext} from '@/shared/contexts/solution-drug'
import {toaster} from '@cypro/ui/toaster'
import {Drawer, Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'

export function SolutionDrawer() {
  const canManageCatalogue = useCan('catalogue.manage')
  const {t} = useTranslate('common')
  const {t: tSolutions} = useTranslate('solutions')
  const {solutionDrug} = useSolutionDrugContext()
  const deleteSolution = useConfirmDeleteSolution()

  async function onDelete() {
    try {
      await deleteSolution({id: solutionDrug.id})
      const drawerId = getSolutionDrawerId(solutionDrug.id)
      drawer.close(drawerId)
      toaster.success({title: t('success'), description: t('resource_deleted_successfully')})
    } catch {}
  }

  const canDelete = isSolutionDeletable(solutionDrug)
  const deleteBtn = <DeleteResourceButton onClick={onDelete} disabled={!canDelete} />

  return (
    <>
      <DrawerHeader>
        <Drawer.Title>{t('solution_details')}</Drawer.Title>
      </DrawerHeader>

      <DrawerBody>
        <SolutionSummary />

        <Tabs.Root defaultValue="about" spaceY="5" lazyMount>
          <SolutionDrawerTabsList />

          <AboutTab />
          <MedicationProfilesTab />
          <HistoryTab />
        </Tabs.Root>
      </DrawerBody>

      {canManageCatalogue && (
        <DrawerFooter display="flex" justifyContent="space-between">
          {/* // TODO: implement active solutions v2 */}
          {!canDelete && <Tooltip content={tSolutions('cannot_delete_message', {tradeNames: 0})}>{deleteBtn}</Tooltip>}

          {canDelete && deleteBtn}

          <LinkButton
            to="/configuration/drug-catalog/solutions/new"
            search={{solutionId: solutionDrug.id}}
            colorPalette="cyan"
            data-e2e="edit-solution"
          >
            {t('edit')}
          </LinkButton>
        </DrawerFooter>
      )}
    </>
  )
}
